import { Select } from "@suraasa/placebo-ui"
import { useQuery } from "@tanstack/react-query"
import api from "api"
import Navbar from "components/Navbar"
import PageContainer from "components/PageContainer"
import useSearchField from "utils/hooks/useSearchField"
import { useSearchParamsHook } from "utils/hooks/useSearchParams"
import { productFilterOptions } from "utils/products"

import OverviewStatCard from "./OverviewStatCard"
import StudentsList from "./StudentsList"

const ListStudentsOrAssignments = () => {
  const { searchParams, updateParam } = useSearchParamsHook({
    course: "",
    product: "",
  })

  const { SearchField, searchText } = useSearchField({
    className: "-mt-2",
    placeholder: "Search by student name or email",
    useSearchStyles: false,
    useSearchParam: true,
  })

  const courses = useQuery({
    queryFn: () => api.courses.list(),
    queryKey: ["courses"],
  })

  const selectedProduct = productFilterOptions.find(
    c => c.label === searchParams.product
  )

  const selectedCourse = courses.data?.courses.find(
    c => c.uuid === searchParams.course
  )

  const overview = useQuery({
    queryFn: () =>
      api.assignments.stats({
        data: {
          ...(selectedProduct && {
            product_filter: {
              parent_item_id: selectedProduct?.value.id || null,
              parent_item_type: selectedProduct?.value.type || null,
              delivery_modes: selectedProduct?.value.deliveryModes || null,
            },
          }),
          ...(selectedCourse && {
            course_ids: [selectedCourse.uuid],
          }),
        },
      }),
    queryKey: [
      "assignment-stats",
      selectedProduct?.value,
      selectedCourse?.uuid,
    ],
  })

  return (
    <>
      <Navbar hideBackButton />
      <PageContainer>
        <div className="flex flex-col gap-1">
          {SearchField}

          <div className="flex gap-1">
            <Select
              options={productFilterOptions}
              placeholder="Filter by product"
              onChange={v => updateParam("product", v?.label)}
              value={selectedProduct}
              isClearable
            />

            <Select
              options={courses.data?.courses}
              placeholder="Filter by course"
              onChange={v => updateParam("course", v?.uuid)}
              value={selectedCourse}
              isLoading={courses.isLoading}
              isClearable
              getOptionLabel={option => option.name}
              getOptionValue={option => option.uuid}
            />
          </div>
        </div>

        <div className="mt-2 flex gap-1">
          <OverviewStatCard
            color="bg-warning-300"
            count={overview.data?.totalSubmissions}
            title="Total Submissions"
          />
          <OverviewStatCard
            color="bg-success-300"
            count={overview.data?.acceptedSubmissions}
            title="Accepted Submissions"
          />
          <OverviewStatCard
            color="bg-critical-300"
            count={overview.data?.pendingReviews}
            title="Pending Reviews"
          />
        </div>

        <StudentsList
          courseId={selectedCourse?.uuid}
          search={searchText}
          product={selectedProduct?.value}
        />
      </PageContainer>
    </>
  )
}

export default ListStudentsOrAssignments
